import React from 'react';

const NotFound = () => {
   return (
      <div>
         <h2>The page you want to show is no Found</h2>
      </div>
   );
};

export default NotFound;